import { render, staticRenderFns } from "./PickUpInfoEdit.vue?vue&type=template&id=78e56025"
import script from "./PickUpInfoEdit.vue?vue&type=script&lang=js"
export * from "./PickUpInfoEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports